<template>
	<section class="wib-hero-section" :style="`background-image: url('${ heroData.background_url }')`">
		<div class="container">
			<div class="wib-hero-section__image">
				<img :src="heroData.logo_url" alt="">
			</div>
			<div class="wib-hero-section__body">
				<h1 class="wib-hero-section__heading">
					{{ heroData.title | stripTags }}
				</h1>
				<div class="wib-hero-section__text" v-html="heroData.body" />
				<a
					class="wib-hero-section__button btn"
					v-scroll-to="{
						el: '#build-it-section',
						offset: -90
					}"
				>
					EXPLORE GAMING PCS
				</a>
				<a
					class="wib-hero-section__video-link"
					v-scroll-to="{
						el: '#video-section',
						offset: -80
					}"
				>
					<img src="/images/icons/play.svg" alt=""> Watch how NZXT Computers are built
				</a>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "WhatIsBldHero",
	props: {
		heroData: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.wib-hero-section {
    padding: 50px 0;
    color: $white;
    background-size: cover;

    &__image {
        margin: 0 auto;
        display: flex;
        justify-content: center;

        @media (max-width: 580px) {
            display: block;
        }

        img {
           height: 330px;

            @media (max-width: 580px) {
                height: auto;
                width: 100%;
            }
        }
    }

    &__body {
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    &__heading {
    }

    &__text {
        max-width: 830px;
        margin: 0 auto;
        font-size: 16px;
        line-height: 21px;
        margin-bottom: 20px;
    }

    &__button {
        color: $white;
        margin: 0 auto 20px;
        padding: 12px 0;
        width: 330px;
        border-radius: 5px;
        background-color: $oldpurple;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all .2s;

        &:hover {
            background-color: $white;
            color: $oldpurple;
        }
    }

    &__video-link {
        color: $orchid;
        font-size: 16px;
        cursor: pointer;

        img {
            margin-right: 2px;
            margin-top: -3px;
            height: 16px;
        }
    }
}
</style>
